import { Radar, Brain, FileText, Target, Bell, Layers } from "lucide-react";

const features = [
  {
    icon: Radar,
    title: "Scan what no one else watches",
    desc: "We index 35+ underground sources — patent filings, niche subreddits, private Discords, foreign marketplaces — so you spot demand months before it floods the mainstream.",
  },
  {
    icon: Brain,
    title: "AI ranks signal vs. noise",
    desc: "Our model cross-references velocity, intent, and buyer language to score every trend on profit potential. No more drowning in raw data dumps.",
  },
  {
    icon: FileText,
    title: "Get a launch blueprint, not a buzzword",
    desc: "Each trend ships with positioning, target buyer, pricing band, supplier or asset suggestions, and a 7-day launch plan. From insight to invoice.",
  },
  {
    icon: Target,
    title: "Stop guessing your next product",
    desc: "Filter by category, capital required, and skill set. The dashboard tells you which opportunity is yours to take — not just which one is hot.",
  },
  {
    icon: Bell,
    title: "Move first, every time",
    desc: "Real-time alerts when a niche you're tracking hits acceleration. The difference between being early and being early enough.",
  },
  {
    icon: Layers,
    title: "One payment. Forever.",
    desc: "No monthly tax on your curiosity. Pay once, scan forever, and let your next ten products come from a single tool.",
  },
];

const Features = () => (
  <section id="features" className="py-32">
    <div className="container">
      <div className="max-w-2xl mb-20">
        <div className="font-mono text-xs text-primary mb-4">// THE ENGINE</div>
        <h2 className="font-display text-4xl md:text-6xl font-bold leading-tight">
          Replace your <span className="text-muted-foreground line-through">12-tab research weekend</span> with a 4-minute scan.
        </h2>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-border rounded-2xl overflow-hidden border border-border">
        {features.map((f, i) => (
          <div
            key={i}
            className="group bg-card p-8 hover:bg-secondary/40 transition-all duration-500 relative overflow-hidden"
          >
            <div className="absolute -right-8 -top-8 w-32 h-32 bg-primary/5 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="relative">
              <div className="w-12 h-12 grid place-items-center rounded-lg bg-primary/10 text-primary mb-6 group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                <f.icon className="w-5 h-5" />
              </div>
              <h3 className="font-display text-xl font-semibold mb-3">{f.title}</h3>
              <p className="text-muted-foreground leading-relaxed text-sm">{f.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Features;
